import { Injectable } from '@angular/core';
import { CustomerGroupsService } from '@symphony-solo/domain/customer-groups/src';
import { ModifiersService } from '@symphony-solo/domain/modifiers/src';
import { PaymentsService } from '@symphony-solo/domain/payments/src';
import { PriceLevelsService } from '@symphony-solo/domain/price-levels/src';
import { TaxRateShiftsService } from '@symphony-solo/domain/taxrate-shifts/src';
import { TaxrateService } from '@symphony-solo/domain/taxrates/src';
import { VersionedData } from '@symphony-solo/shared/http/src';
import { forkJoin, Observable } from 'rxjs';

@Injectable()
export class SyncDataService {
  private versionedHash = 'EMPTY_HASH';

  constructor(
    private customerGroupsService: CustomerGroupsService,
    private taxRateShiftsService: TaxRateShiftsService,
    private taxrateService: TaxrateService,
    private paymentsService: PaymentsService,
    private modifiersService: ModifiersService,
    private priceLevelsService: PriceLevelsService
  ) {}

  public getData(): Observable<VersionedData<any>[]> {
    return forkJoin([
      // todo: add more retrieve data services
      this.customerGroupsService.getCustomerGroups(this.versionedHash),
      this.taxRateShiftsService.getTaxRateShifts(this.versionedHash),
      this.taxrateService.getTaxrates(this.versionedHash),
      this.paymentsService.getPayments(this.versionedHash),
      this.modifiersService.getModifiers(this.versionedHash),
      this.priceLevelsService.getPriceLevels(this.versionedHash),
    ]);
  }
}
